exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/_wks-ext.js
// module id = 412
// module chunks = 0